export default __webpack_public_path__ + "static/media/cheque_CAD.0cbef1e2.jpg";